<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 32 32"
    :width="size"
    :height="size"
  >
    <path
      fill="currentColor"
      d="M16 32c-8.821-0.009-15.968-7.162-15.968-15.984 0-8.828 7.156-15.984 15.984-15.984s15.984 7.156 15.984 15.984c0 1.533-0.216 3.016-0.619 4.42l0.028-0.113-0.439 2.033-9.333-5.191 1.297-2.331 6.203 3.451c0.125-0.686 0.197-1.475 0.197-2.281 0-7.361-5.967-13.329-13.329-13.329s-13.329 5.967-13.329 13.329c0 7.361 5.967 13.329 13.329 13.329 2.63 0 5.083-0.762 7.148-2.077l-0.054 0.032 1.422 2.256c-2.411 1.54-5.352 2.455-8.506 2.455-0.005 0-0.010 0-0.016 0h0.001z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgReload',

  props: {
    size: {
      type: [Number, String],
      default: 32,
    },
  },
}
</script>
